module.exports = __webpack_public_path__ + "static/media/ball_005_c.b7750001.png";